'use client'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="text-center">
        <h1 className="text-2xl font-semibold mb-2">Page Not Found</h1>
        <p className="text-subtext">The page you’re looking for doesn’t exist.</p>
      </div>
    </div>
  )
}

